<template lang="html">
  <div class="bottomnav">
    <div class="bottomnav__section">
      <router-link to="/student/" class="bottomnav__section__nav">
        <DashboardIcon
          width="22px"
          height="22px"
          color="#fff"
        />
      </router-link>
      <router-link to="/student/bookcoach" class="bottomnav__section__nav">
        <BookacoachIcon
          width="22px"
          height="22px"
          color="#fff"
        />
      </router-link>
      <router-link to="/student/studyprogressreport" class="bottomnav__section__nav">
        <StudydashIcon
          width="22px"
          height="22px"
          color="#fff"
        />
      </router-link>
      <router-link to="/student/sessions" class="bottomnav__section__nav">
        <SessionsIcon
          width="22px"
          height="22px"
          color="#fff"
        />
      </router-link>
      <router-link to="/student/token" class="bottomnav__section__nav">
        <TokensIcon
          width="22px"
          height="22px"
          color="#fff"
        />
      </router-link>
      <div class="bottomnav__section__nav" @click="getSessionSimulator">
        <router-link to="/student/#">
          <SimulatorIcon
          width="22px"
          height="22px"
          color="#fff"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardIcon from '../../components/icons/DashboardIcon'
import BookacoachIcon from '../../components/icons/BookacoachIcon'
import StudydashIcon from '../../components/icons/StudydashIcon'
import SessionsIcon from '../../components/icons/SessionsIcon'
// import TokensIcon from '../../views/Lottie/TokenLottie'
import TokensIcon from '../../components/icons/TokensIcon'
import SimulatorIcon from '../../components/icons/SimulatorIcon'

export default {
  components: {
    DashboardIcon,
    BookacoachIcon,
    StudydashIcon,
    SessionsIcon,
    TokensIcon,
    SimulatorIcon
  },
  methods: {
    getSessionSimulator () {
      this.$store.dispatch("GET_SESSION_SIMULATOR")
    }
  }
}
</script>

<style lang="scss">
  @import './Bottomnav.scss'
</style>



// WEBPACK FOOTER //
// src/student-components/layout/Bottomnav.vue